module.exports = __webpack_public_path__ + "static/media/8DBE8CED-C484-449F-9D22-1C8B79D87E73.89d9852d.jpeg";